import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isAudiExclusivePdfVisibleSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('audiExclusivePdf'),
)

export default isAudiExclusivePdfVisibleSelector
